<template>
    <div>
        <div>
            <div class="campaign-image" :style="{'background-image': `url('${image.fullImageUrl}')`}"></div>
        </div>
    </div>
</template>
<script>

export default {
    name: "Picture",
    props: {
        purchase: { type: Object, required: true },
    },
    data: function() {
        return {
            image: this.purchase,
        };
    },
}
</script>
<style lang="scss" scoped>
    @import "../../style/base/image.scss";
    .campaign-image {
        border-radius: 10px;
        @include boxRatio($ratio: 66.66%);
    }
</style>
